import { useMemo } from 'react'
import { find, isEmpty, keys, reduce, some } from 'lodash'

import { USER_ASSIGNMENT_ACTION_TYPE } from '../../common/constants'

import { useLoggedInUser } from '../../account/hooks'

const useMenuCurationTaskAllocatedUsers = menuCurationTask => {
  const { id } = useLoggedInUser()

  const allocatedUsers = useMemo(
    () =>
      reduce(
        keys(USER_ASSIGNMENT_ACTION_TYPE),
        (acc, action) => {
          const allocation = find(
            menuCurationTask.priorityTaskAllocations,
            allocation =>
              allocation.allocatedRole === action &&
              !allocation.priorityTask?.isDone,
          )

          if (!isEmpty(allocation)) {
            return {
              ...acc,
              [action]: allocation.allocatedUser,
            }
          }

          return acc
        },
        {},
      ),
    [menuCurationTask],
  )

  const isCurrentUserAllocated = some(
    keys(allocatedUsers),
    key => allocatedUsers[key]?.id === id,
  )

  const isTaskAllocated = some(
    keys(allocatedUsers),
    key => !isEmpty(allocatedUsers[key]),
  )

  return {
    isCurrentUserAllocated,
    isTaskAllocated,
    allocatedCurator: allocatedUsers[USER_ASSIGNMENT_ACTION_TYPE.CURATION],
    allocatedTierOneCurator:
      allocatedUsers[USER_ASSIGNMENT_ACTION_TYPE.TIER_ONE],
    allocatedQa: allocatedUsers[USER_ASSIGNMENT_ACTION_TYPE.QA],
    allocatedQc: allocatedUsers[USER_ASSIGNMENT_ACTION_TYPE.QC],
  }
}
export default useMenuCurationTaskAllocatedUsers
